
<ng-container *ngIf="statesData$ | async as statesData">
  <div class="overall-stats">

    <div class="toolbar">
      <h2>Overall Stats</h2>
    </div>

    <div class="stats-wrapper">

      <div class="floor">

        <div class="label">Current Lowest Price {{ environment.tokenName }}</div>
        <div class="value">
          
          Ξ{{ (((stateSvc.aggregatedFloor$ | async) || 0)) | formatCash }}
          (${{ (((stateSvc.aggregatedFloor$ | async) || 0) * ((dataSvc.usd$ | async) || 0)) | formatCash }} USD)
           
        </div>
      </div>

      <div class="volume">
        <div class="label">Trading Volume</div>
        <div class="value">
          Ξ{{ statsData?.volume | weiToEth | formatCash }}
        </div>
      </div>

      @if (dataSvc.statesStats$ | async; as stats) {
        @if ((stateSvc.activePeriod$ | async)?.key; as periodKey) {
          <div class="sales">
            <div class="label">Number of Sales</div>
            <div class="value">{{ (stats[periodKey]).sales }}</div>
          </div>
        }
      }

      <div class="owners" *ngIf="environment.collection !== 'cryptopunks-v1'">
        <div class="label">Unique Wallet Count</div>
        <div class="value">{{ statsData.owners | number }} <span class="plus" *ngIf="statsData.newOwners">{{ statsData.newOwners > 0 ? '+' : '' }}{{ statsData.newOwners | number }}</span></div>
      </div>

      <div class="period-select-wrapper">
        <ng-select
          [items]="stateSvc.periods"
          [clearable]="false"
          [searchable]="false"
          bindValue="key"
          bindLabel="value"
          [(ngModel)]="stateSvc.defaultPeriod"
          (change)="setAcivePeriod($event)">
        </ng-select>
      </div>
    </div>
  </div>

  <app-chart
    *ngIf="(statesData$ | async)?.length"
    [chartData]="statesData$ | async"
    [period]="(stateSvc.activePeriod$ | async)!">
  </app-chart>
</ng-container>

<!-- <ng-template #moreIcon>
  <svg height="6" viewBox="0 0 8 6" width="8" xmlns="http://www.w3.org/2000/svg"><path d="m4 3.06383532 2.29289322-2.2709421c.39052429-.39052429 1.02368927-.39052429 1.41421356 0 .36048396.36048396.3882135.92771502.08318861 1.32000622l-.08318861.09420734-3 3c-.03539405.03539405-.0727812.06758027-.11180017.09655864l-.11124451.07166341-.11272608.05344568-.14204519.04481478-.11435268.01987002-.11493815.00654069-.11662113-.00672773-.1126697-.01968298-.11232487-.03345995-.08160585-.0338027-.0974872-.05232209-.09219069-.06370916c-.03679738-.02905711-.06632198-.05530324-.09420734-.08318861l-3-3c-.39052429-.39052429-.39052429-1.02368927 0-1.41421356.36048396-.36048396.92771502-.3882135 1.32000622-.08318861l.09420734.08318861z" fill="#fff"/></svg>
</ng-template>

<ng-template #loadingIcon>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve"><path fill="rgba(var(--purple), 1)" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"><animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" /></path></svg>
</ng-template>

<ng-template #arrow>
  <svg height="7" viewBox="0 0 11 7" width="11" xmlns="http://www.w3.org/2000/svg"><path d="m9.31045041.79289322h-8.13725824c-.44182781 0-.80000001.3581722-.80000001.80000001 0 .2121732.08428547.41565633.23431457.56568543l4.06862913 4.06862913c.31241943.31241943.81895142.31241943 1.13137086 0l4.06862912-4.06862913c.31241946-.31241943.31241946-.81895142 0-1.13137086-.1500291-.15002911-.35351223-.23431458-.56568543-.23431458z" fill="#d8d8d8" fill-rule="evenodd"/></svg>
</ng-template>
 -->
